/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsFxEventsClientPublicConfig, FxIdDomainSettingsFxEventsClientPublicConfigFromJSONTyped, FxIdDomainSettingsFxEventsClientPublicConfigToJSON, } from './FxIdDomainSettingsFxEventsClientPublicConfig';
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsFxEventsClientPublicConfig(json)) {
        return FxIdDomainSettingsFxEventsClientPublicConfigFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFxEventsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsFxEventsClientPublicConfig(value)) {
        return FxIdDomainSettingsFxEventsClientPublicConfigToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsFxEvents.js.map